import MapWorkspace from "../components/personal/main_page/MapWorkspace";
import MainNavbar from "../components/reuse/navbar";

export default function MainPage(){
    return(
        <>
        <div >
            <MainNavbar/>
        </div>
        <MapWorkspace />
        </>
    )
}
